export default __webpack_public_path__ + "static/media/settings.3d8a53b4.svg";